import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ForgetPasswordRoutingModule } from './forget-password-routing.module';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { SnackbarMessageModule } from 'src/app/components/snackbar-message/snackbar-message.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { ForgetPasswordVerifyCodeComponent } from './components/forget-password-verify-code/forget-password-verify-code.component';


@NgModule({
  declarations: [
    ForgetPasswordComponent,
    ForgetPasswordVerifyCodeComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    SnackbarMessageModule,
    MatMenuModule,
    MatSnackBarModule,
    MatIconModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    ForgetPasswordRoutingModule
  ]
})
export class ForgetPasswordModule { }
